/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type LinkDeliveryPreferentialOriginDocumentInput = {
  id?: string | null,
  delivery?: LinkDeliveryInput | null,
  preferentialOriginDocument?: LinkPreferentialOriginDocumentInput | null,
  author?: string | null,
};

export type LinkDeliveryInput = {
  productCode?: string | null,
  factoryCommercialInvoiceNumber?: string | null,
  transportEquipmentNumber?: string | null,
};

export type LinkPreferentialOriginDocumentInput = {
  number?: string | null,
  destinationCountry?: string | null,
  stpCode?: string | null,
};

export type DeliveryPreferentialOriginDocument = {
  __typename: "DeliveryPreferentialOriginDocument",
  id?: string | null,
  delivery?: Delivery | null,
  preferentialOriginDocument?: PreferentialOriginDocument | null,
};

export type Delivery = {
  __typename: "Delivery",
  deliveryNoteNumber?: string | null,
  productCode?: string | null,
  purchaseOrderNumber?: string | null,
  purchaseOrderLineNumber?: string | null,
  factoryCommercialInvoiceNumber?: string | null,
  transportEquipmentNumber?: string | null,
  materialCountryOfOrigin?: string | null,
  transportationMode?: string | null,
  carrier?: string | null,
  forwarder?: string | null,
  billOfLadingNumber?: string | null,
  shipmentType?: string | null,
  departureDate?: string | null,
  dischargeDate?: string | null,
  factoryCode?: string | null,
};

export type PreferentialOriginDocument = {
  __typename: "PreferentialOriginDocument",
  number?: string | null,
  type?: string | null,
  quantity?: number | null,
  destinationCountry?: string | null,
  stpCode?: string | null,
  stpCodeMasterData?: string | null,
  stpQualifier?: StpQualifier | null,
};

export enum StpQualifier {
  Y = "Y",
  N = "N",
  UNKNOWN = "UNKNOWN",
}


export type ReportCriteriaInput = {
  departureDateFrom: string,
  departureDateTo: string,
  manufacturerCountryOfOrigins: Array< string >,
  podNumberFilled: boolean,
  transportationModes: Array< string >,
  forwarders?: Array< string > | null,
};

export type StorePreferentialOriginDocumentForLinkingDeliveryMutationVariables = {
  inputs?: Array< LinkDeliveryPreferentialOriginDocumentInput | null > | null,
};

export type StorePreferentialOriginDocumentForLinkingDeliveryMutation = {
  storePreferentialOriginDocumentForLinkingDelivery?: boolean | null,
};

export type FindForwardersQueryVariables = {
};

export type FindForwardersQuery = {
  findForwarders: Array< string >,
};

export type FindManufacturerCountryOfOriginsQueryVariables = {
};

export type FindManufacturerCountryOfOriginsQuery = {
  findManufacturerCountryOfOrigins: Array< string >,
};

export type FindDeliveryPreferentialOriginDocumentsByFilterQueryVariables = {
  filter?: string | null,
};

export type FindDeliveryPreferentialOriginDocumentsByFilterQuery = {
  findDeliveryPreferentialOriginDocumentsByFilter:  Array< {
    __typename: "DeliveryPreferentialOriginDocument",
    id?: string | null,
    delivery?:  {
      __typename: "Delivery",
      deliveryNoteNumber?: string | null,
      productCode?: string | null,
      purchaseOrderNumber?: string | null,
      purchaseOrderLineNumber?: string | null,
      factoryCommercialInvoiceNumber?: string | null,
      transportEquipmentNumber?: string | null,
      materialCountryOfOrigin?: string | null,
      transportationMode?: string | null,
      carrier?: string | null,
      forwarder?: string | null,
      billOfLadingNumber?: string | null,
      shipmentType?: string | null,
      departureDate?: string | null,
      dischargeDate?: string | null,
      factoryCode?: string | null,
    } | null,
    preferentialOriginDocument?:  {
      __typename: "PreferentialOriginDocument",
      number?: string | null,
      type?: string | null,
      quantity?: number | null,
      destinationCountry?: string | null,
      stpCode?: string | null,
      stpCodeMasterData?: string | null,
      stpQualifier?: StpQualifier | null,
    } | null,
  } | null >,
};

export type FindDeliveryPreferentialOriginDocumentsByReportCriteriaQueryVariables = {
  criteria: ReportCriteriaInput,
};

export type FindDeliveryPreferentialOriginDocumentsByReportCriteriaQuery = {
  findDeliveryPreferentialOriginDocumentsByReportCriteria:  Array< {
    __typename: "DeliveryPreferentialOriginDocument",
    id?: string | null,
    delivery?:  {
      __typename: "Delivery",
      deliveryNoteNumber?: string | null,
      productCode?: string | null,
      purchaseOrderNumber?: string | null,
      purchaseOrderLineNumber?: string | null,
      factoryCommercialInvoiceNumber?: string | null,
      transportEquipmentNumber?: string | null,
      materialCountryOfOrigin?: string | null,
      transportationMode?: string | null,
      carrier?: string | null,
      forwarder?: string | null,
      billOfLadingNumber?: string | null,
      shipmentType?: string | null,
      departureDate?: string | null,
      dischargeDate?: string | null,
      factoryCode?: string | null,
    } | null,
    preferentialOriginDocument?:  {
      __typename: "PreferentialOriginDocument",
      number?: string | null,
      type?: string | null,
      quantity?: number | null,
      destinationCountry?: string | null,
      stpCode?: string | null,
      stpCodeMasterData?: string | null,
      stpQualifier?: StpQualifier | null,
    } | null,
  } | null >,
};
